import { render, staticRenderFns } from "./SmsFooter.vue?vue&type=template&id=7637fb1c&scoped=true"
import script from "./SmsFooter.vue?vue&type=script&lang=js"
export * from "./SmsFooter.vue?vue&type=script&lang=js"
import style0 from "./SmsFooter.vue?vue&type=style&index=0&id=7637fb1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637fb1c",
  null
  
)

export default component.exports